import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import RelateComputer from './RelateComputer';
import GeometryGraphOperation from '../GeometryGraphOperation';
import RectangleContains from '../predicate/RectangleContains';
import RectangleIntersects from '../predicate/RectangleIntersects';
var RelateOp = /*#__PURE__*/function (_GeometryGraphOperati) {
  _inherits(RelateOp, _GeometryGraphOperati);
  function RelateOp() {
    var _this;
    _classCallCheck(this, RelateOp);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(RelateOp).call(this));
    RelateOp.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(RelateOp, [{
    key: "getIntersectionMatrix",
    value: function getIntersectionMatrix() {
      return this._relate.computeIM();
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._relate = null;
      if (arguments.length === 2) {
        var g0 = arguments[0],
          g1 = arguments[1];
        GeometryGraphOperation.constructor_.call(this, g0, g1);
        this._relate = new RelateComputer(this._arg);
      } else if (arguments.length === 3) {
        var _g = arguments[0],
          _g2 = arguments[1],
          boundaryNodeRule = arguments[2];
        GeometryGraphOperation.constructor_.call(this, _g, _g2, boundaryNodeRule);
        this._relate = new RelateComputer(this._arg);
      }
    }
  }, {
    key: "covers",
    value: function covers(g1, g2) {
      if (g2.getDimension() === 2 && g1.getDimension() < 2) return false;
      if (g2.getDimension() === 1 && g1.getDimension() < 1 && g2.getLength() > 0.0) return false;
      if (!g1.getEnvelopeInternal().covers(g2.getEnvelopeInternal())) return false;
      if (g1.isRectangle()) return true;
      return new RelateOp(g1, g2).getIntersectionMatrix().isCovers();
    }
  }, {
    key: "intersects",
    value: function intersects(g1, g2) {
      if (!g1.getEnvelopeInternal().intersects(g2.getEnvelopeInternal())) return false;
      if (g1.isRectangle()) return RectangleIntersects.intersects(g1, g2);
      if (g2.isRectangle()) return RectangleIntersects.intersects(g2, g1);
      if (g1.isGeometryCollection() || g2.isGeometryCollection()) {
        var r = false;
        for (var i = 0; i < g1.getNumGeometries(); i++) for (var j = 0; j < g2.getNumGeometries(); j++) if (g1.getGeometryN(i).intersects(g2.getGeometryN(j))) return true;
        return false;
      }
      return new RelateOp(g1, g2).getIntersectionMatrix().isIntersects();
    }
  }, {
    key: "touches",
    value: function touches(g1, g2) {
      if (!g1.getEnvelopeInternal().intersects(g2.getEnvelopeInternal())) return false;
      return new RelateOp(g1, g2).getIntersectionMatrix().isTouches(g1.getDimension(), g2.getDimension());
    }
  }, {
    key: "equalsTopo",
    value: function equalsTopo(g1, g2) {
      if (!g1.getEnvelopeInternal().equals(g2.getEnvelopeInternal())) return false;
      return RelateOp.relate(g1, g2).isEquals(g1.getDimension(), g2.getDimension());
    }
  }, {
    key: "relate",
    value: function relate() {
      if (arguments.length === 2) {
        var a = arguments[0],
          b = arguments[1];
        var relOp = new RelateOp(a, b);
        var im = relOp.getIntersectionMatrix();
        return im;
      } else if (arguments.length === 3) {
        var _a = arguments[0],
          _b = arguments[1],
          boundaryNodeRule = arguments[2];
        var _relOp = new RelateOp(_a, _b, boundaryNodeRule);
        var _im = _relOp.getIntersectionMatrix();
        return _im;
      }
    }
  }, {
    key: "overlaps",
    value: function overlaps(g1, g2) {
      if (!g1.getEnvelopeInternal().intersects(g2.getEnvelopeInternal())) return false;
      return new RelateOp(g1, g2).getIntersectionMatrix().isOverlaps(g1.getDimension(), g2.getDimension());
    }
  }, {
    key: "crosses",
    value: function crosses(g1, g2) {
      if (!g1.getEnvelopeInternal().intersects(g2.getEnvelopeInternal())) return false;
      return new RelateOp(g1, g2).getIntersectionMatrix().isCrosses(g1.getDimension(), g2.getDimension());
    }
  }, {
    key: "contains",
    value: function contains(g1, g2) {
      if (g2.getDimension() === 2 && g1.getDimension() < 2) return false;
      if (g2.getDimension() === 1 && g1.getDimension() < 1 && g2.getLength() > 0.0) return false;
      if (!g1.getEnvelopeInternal().contains(g2.getEnvelopeInternal())) return false;
      if (g1.isRectangle()) return RectangleContains.contains(g1, g2);
      return new RelateOp(g1, g2).getIntersectionMatrix().isContains();
    }
  }]);
  return RelateOp;
}(GeometryGraphOperation);
export { RelateOp as default };